<script>
  import Help from "../components/help.svelte";
  let helpId;
  export let phase;
  switch (phase){
      case 'nursery':
      helpId = 'Help1';
      break;
      case 'reception':
      helpId = 'Help23';
      break;
      case 'junior':
      helpId = 'Help24';
      break;
      case 'secondary':
      helpId = 'Help2';
      break;
      case 'fourteennineteen':
      helpId = 'Help43';
      break;
  }
  </script>
  <svelte:head>
  <title>Help | eAdmissions</title>
</svelte:head>

  <Help helpId={helpId} showSearchOption={false}/>
 
